import * as React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {styles} from './PremierOrderDetails.style';

interface Price {
  total: number;
  currencyCode: string;
}

interface NextScheduledPremierOrder {
  scheduledOn: string;
  cv: number;
  price: Price;
}

interface Rewards {
  balance: number;
  currencyCode: string;
}

interface PremierOrderDetailsProps {
  recordData: {
    nextScheduledPremierOrder?: NextScheduledPremierOrder;
    rewards: Rewards;
  };
  tt: (key: string, value: string) => string;
}

export const PremierOrderDetails: React.FC<PremierOrderDetailsProps> = ({
  tt = withTranslation.ttDefaultProp,
  recordData = {},
}) => {
  const {
    nextScheduledPremierOrder = {
      scheduledOn: '',
      cv: 0,
      price: {total: 0, currencyCode: ''},
    },
    rewards = {balance: 0, currencyCode: ''},
  } = recordData;

  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );

  return (
    <Gutter>
      <View style={[styles.attributeLine, styles.borderTop]}>
        <Text emphasis="medium">
          {tt('attribute.orderValue', 'Order Value')}
        </Text>
        <FormattedNumber
          testID={UserProfileModal.orderValue}
          value={nextScheduledPremierOrder.price.total}
          decimalPlaces={2}
          currencyCode={nextScheduledPremierOrder.price.currencyCode}
          boldText
        />
      </View>

      <View style={styles.attributeLine}>
        <Text emphasis="medium">
          {tt('attribute.scheduleDate', 'Scheduled Date')}
        </Text>
        <Text variant="button" testID={UserProfileModal.scheduledDate}>
          {getDateUtilDefaultInstance().formatDate(
            nextScheduledPremierOrder.scheduledOn,
            'MMMM d, yyyy',
          )}
        </Text>
      </View>

      <View style={styles.attributeLine}>
        <Text emphasis="medium">{tt('attribute.cv', 'CV')}</Text>
        <FormattedNumber
          testID={UserProfileModal.cvValue}
          value={nextScheduledPremierOrder.cv}
          boldText={true}
        />
      </View>

      {updatePremierPlus ? (
        ''
      ) : (
        <View style={styles.attributeLine}>
          <Text emphasis="medium">
            {tt('attribute.rewardsBalance', 'Rewards Balance')}
          </Text>
          <FormattedNumber
            testID={UserProfileModal.rewardsBalance}
            value={rewards.balance}
            decimalPlaces={2}
            currencyCode={rewards.currencyCode}
            boldText
          />
        </View>
      )}
      {/*<View style={styles.attributeLine}>
        <Text emphasis="medium">
          {tt('attribute.creditsBalance', 'Wellness Credits Balance')}
        </Text>
        <FormattedNumber
          value={wellnessCredits.balance}
          decimalPlaces={2}
          currencyCode={wellnessCredits.currencyCode}
          boldText={true}
        />
      </View>*/}
    </Gutter>
  );
};

export default withTranslation('reportCardContent.premierOrderDetails')(
  PremierOrderDetails,
);
